/* eslint-disable react/prop-types, react/jsx-handler-names */

import PropTypes from "prop-types";
import React from "react";

import { isEqual } from "lodash";

import Grid from "@mui/material/Grid";
import NoSsr from "@mui/material/NoSsr";
import MuiTextField from "@mui/material/TextField";
import { withStyles } from "@mui/styles";

import Autocomplete from "@mui/material/Autocomplete";

import usStates from "@us-states";
import {
  filterStateOptions,
  findExactStateMatch,
} from "~/shared/utils/usStateOptions.js";

import consultationStyles from "../styles/consultationStyles.js";

// The message under the state field when none is chosen. signup.jsx reuses it
// for the server's us_state_required error, so the two always say the same.
export const US_STATE_REQUIRED_MESSAGE = "Please select the State you live in";

// Built from app/config/us_states.json, the single list shared with Go
// (app.IsUSStateCode / app.USStateName) and the EMR patient validation.
export const stateSuggestions = usStates.map(({ code, name }) => ({
  value: code,
  label: `${name} (${code})`,
}));

class AutocompleteUSStates extends React.Component {
  constructor(props) {
    super(props);

    // console.log("constructor autocompleteUSState props: ", props);
    // console.log("constructor initialvalue: ", props.initialValue);

    this.state = {
      initialStateChanged: false,
      usState: props.initialValue,
      inputValue: "",
      // usState: { label: "Kansas", value: "KS" },
    };
  }

  componentDidUpdate(prevProps) {
    // When VisitorAPI resolves async, initialValue updates but Formik doesn't
    // know about it. Sync the value to Formik so validation passes.
    if (
      !this.state.initialStateChanged &&
      this.props.initialValue &&
      !isEqual(prevProps.initialValue, this.props.initialValue)
    ) {
      const { formikProps } = this.props;
      formikProps.setFieldValue(this.props.name, this.props.initialValue);
    }
  }

  // https://codesandbox.io/s/jRzE53pqR

  render() {
    // console.log("... rendering autocompleteUSStates");
    // console.log("autocompleteUSState state: ", this.state);
    const { classes, formikProps } = this.props;

    // console.log("props: ", this.props);

    // if (!this.state.initialStateChanged && this.props.initialValue) {
    //   console.log("initialValue: ", this.props.initialValue);
    //   formikProps.setFieldValue(this.props.name, this.state.usState);
    // }

    // if (!this.state.initialStateChanged) {
    //   formikProps.setFieldValue(this.props.name, this.props.initialValue);
    // }

    // const fieldProps = formikProps.getFieldProps(this.props.name);

    // Shown once the field is touched (a submit, or the Google button's gated
    // click) and still has no state. MUI's own `error` + `helperText`, so the
    // field looks exactly like the form's other errored fields (the look is
    // defined once: baseStyles.js fieldError*, applied by patientTheme), and the
    // input is marked aria-invalid and described by the message.
    const showError = Boolean(
      formikProps.touched[this.props.name] &&
      formikProps.errors[this.props.name] != null,
    );

    return (
      <React.Fragment>
        <NoSsr>
          <Autocomplete
            // formikProps={formikProps}
            autoComplete={true}
            disableClearable
            autoSelect={true}
            options={stateSuggestions}
            getOptionLabel={(option) => option.label}
            isOptionEqualToValue={(option, value) => {
              return isEqual(option, value);
            }}
            inputValue={this.state.inputValue}
            onInputChange={(event, value) => {
              // Remove non-alphabetical characters (except spaces and parentheses) from the input
              const sanitizedValue = value.replace(/[^a-zA-Z\s(,)]/g, "");
              if (sanitizedValue !== this.state.inputValue) {
                this.setState({ inputValue: sanitizedValue });
              }
            }}
            // Highlight the first option only on an exact match (code or name),
            // so Enter / blur (autoSelect) picks it; otherwise nothing is
            // pre-highlighted, as before.
            autoHighlight={
              findExactStateMatch(stateSuggestions, this.state.inputValue) !==
              undefined
            }
            filterOptions={(options, state) =>
              filterStateOptions(options, state.inputValue)
            }
            // style={{ width: 300 }}
            renderInput={(params) => {
              return (
                <Grid
                  container
                  spacing={1}
                  alignItems="flex-end"
                  justifyContent="center"
                >
                  <Grid item style={{ width: "100%" }}>
                    <label htmlFor={params.id} className={classes.label}>
                      US State you are in
                    </label>
                    <MuiTextField
                      variant="outlined"
                      {...params}
                      error={showError}
                      helperText={
                        showError ? US_STATE_REQUIRED_MESSAGE : undefined
                      }
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: "dont-fill-me-pls", // disable browser autofill
                        placeholder: "Select State",
                      }}
                    />
                  </Grid>
                </Grid>
              );
            }}
            value={
              this.state.initialStateChanged
                ? this.state.usState
                : this.props.initialValue || null
            }
            onChange={(event, data) => {
              // console.log("event:", event);
              // console.log("data:", data);

              if (data) {
                // console.log("onChange: setting field value to: ", data);
                formikProps.setFieldValue(this.props.name, {
                  label: data.label,
                  value: data.value,
                });

                this.setState({
                  initialStateChanged: true,
                  usState: {
                    label: data.label,
                    value: data.value,
                  },
                  inputValue: "",
                });
              }
            }}
          />
        </NoSsr>
      </React.Fragment>
    );
  }
}

AutocompleteUSStates.propTypes = {
  classes: PropTypes.object.isRequired,
  // theme: PropTypes.object.isRequired
};

// export default withStyles(styles, { withTheme: true })(AutocompleteUSStates);
export default withStyles(consultationStyles, { withTheme: true })(
  AutocompleteUSStates,
);
